/**
 * Calculate the net line total for a sales request item, accounting for discount.
 * Formula: unitPrice * quantity * (1 - discountPercent / 100)
 * Result is rounded to integer to match BSale's line item calculation.
 */
export function calcLineTotal(
  unitPrice: number,
  quantity: number,
  discountPercent: number = 0
): number {
  return Math.round(unitPrice * quantity * (1 - discountPercent / 100));
}

/**
 * Calculate the order total from a list of items with optional discounts.
 */
export function calcOrderTotal(
  items: Array<{
    unitPrice: number;
    quantity: number;
    discountPercent?: number;
  }>
): number {
  return items.reduce(
    (sum, item) =>
      sum +
      calcLineTotal(item.unitPrice, item.quantity, item.discountPercent ?? 0),
    0
  );
}
